import { render, staticRenderFns } from "./year-table.vue?vue&type=template&id=49ec5623&scoped=true&"
import script from "./year-table.vue?vue&type=script&lang=js&"
export * from "./year-table.vue?vue&type=script&lang=js&"
import style0 from "./year-table.vue?vue&type=style&index=0&id=49ec5623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec5623",
  null
  
)

export default component.exports